const WeSkiLogo = () => {
  return (
    <img
      width={130}
      height={26}
      src="https://res.cloudinary.com/ht4mr7djk/image/upload/v1727341362/weski_logo_horiznotal.svg"
      alt="weSki logo"
    />
  );
};

export default WeSkiLogo;
